@if (providers().length) {
  @if (withDivider) {
    <div class="action-divider">
      <hr />
      <span>{{ 'o' | translate }}</span>
      <hr />
    </div>
  }

  @for (provider of providers(); track provider) {
    <button type="button" class="social-login-button" (click)="loginWith(provider)">
      @switch (provider) {
        @case ('google') {
          <svg class="social-login-button__logo" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
        }
        @case ('meta') {
          <svg class="social-login-button__logo" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path fill="#1877F2" d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078V12h3.047V9.356c0-3.007 1.792-4.668 4.533-4.668 1.312 0 2.686.234 2.686.234v2.953H15.83c-1.491 0-1.956.925-1.956 1.874V12h3.328l-.532 3.469h-2.796v8.385C19.612 22.954 24 17.99 24 12z"/>
          </svg>
        }
        @case ('apple') {
          <svg class="social-login-button__logo" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path fill="#000000" d="M16.365 1.43c0 1.14-.42 2.19-1.25 3.11-.87.98-2.02 1.55-3.11 1.46-.05-1.09.44-2.22 1.24-3.11.85-.94 2.13-1.56 3.12-1.46zM20.6 17.24c-.52 1.2-.77 1.73-1.44 2.79-.94 1.48-2.26 3.33-3.9 3.34-1.46.02-1.83-.95-3.81-.94-1.98.01-2.39.97-3.85.95-1.64-.02-2.89-1.68-3.83-3.16C1.14 16.08.86 11.32 2.62 8.79c1.25-1.79 3.22-2.84 5.07-2.84 1.88 0 3.07 1.03 4.63 1.03 1.51 0 2.43-1.03 4.61-1.03 1.65 0 3.39.9 4.63 2.45-4.07 2.23-3.41 8.04-.96 8.84z"/>
          </svg>
        }
      }
      <span>{{ labels[provider] | translate }}</span>
    </button>
  }
}
